import React from "react";
import { Route, Switch } from "react-router-dom";
import home from "./home";
import requestQuotation from "./requestQuotation";
import sourceYourCargo from "./sourceYourCargo";
import myProducts from "./myProducts";
import enquiries from "./enquiries";
import myProfile from "./myProfile";
import settings from "./settings";
import BusinessCard from "./businessCard";
import UserProfile from "./userProfile";
import promotions from "./promotions";
import BannerView from "./home/banner/bannerView";
import sellRODTEP from "./sellRODTEP";
import Unclaimedcargo from "./unclaimedcargo/Unclaimedcargo";
import Unclaimedcargoverify from "./unclaimedcargo/Unclaimedcargoverify"
import ExporterData from  "./exporterData/index"
import UpdatefreightratList from "./updateFreightRates/UpdatefreightrateList"
import Updatefreightexporter from "./updateFreightRates/Updatefreightexporter";
import UpdatefreigtrateDetails from "./updateFreightRates/UpdatefreightrateDetails"
import UpdatesfreightRates from "./updateFreightRates/Updatesfreightrates"
import UpdateAllfreightrates from "./updateFreightRates/UpdateAllfreightrates"
import Updatefreightrate from "./updateFreightRates/index"
import chatMessages from "./chatMessages"
import subscriptionUser from "./subscriptionPlan/index"
import userPolicyUpdates from "./userPolicyUpdates"
import requestFreightRates from "./requestFreightRates"
import requestCha from "./requestCha"
import offerYourCargo from "./offerYourCargo"
import cargoOffers from "./cargoOffers"
import GTMWrapper from "../components/GTMWrapper"
import priceCalculator from "./priceCalculator"
import offerYourCargoExporter from "./offerYourCargoExporter"
import cargoOffersBuyer from "./cargoOffersBuyer"
import FreightBookings from "./freightBookings/index"
import FreightBusinessCard from "./freightBusinessCard"
import exporterBusinessCard from "./exporterBusinessCard"
import cargoOfferAdminToBuyer from "./cargoOfferAdminToBuyer"
import contactDetails from "./contactDetails"

const App = ({ match }) => (
  <GTMWrapper>
  <div className="gx-main-content-wrapper" style={{ paddingBottom: "60px"}}>
    <Switch>
      <Route exact path={`${match.url}`} component={home} />
      <Route path={`${match.url}rfq`} component={requestQuotation} />
      <Route path={`${match.url}source-your-cargo`} component={sourceYourCargo} />
      <Route path={`${match.url}my-products`} component={myProducts} />
      <Route path={`${match.url}enquiries`} component={enquiries} />
      <Route path={`${match.url}business-card`} component={BusinessCard} />
      <Route path={`${match.url}my-profile`} component={myProfile} />
      <Route path={`${match.url}settings`} component={settings} />
      <Route path={`${match.url}user-profile`} component={UserProfile} />
      <Route path={`${match.url}promotions`} component={promotions} />
      <Route path={`${match.url}unclaimed-cargo`} component={Unclaimedcargo} />
      <Route path={`${match.url}unclaimed-cargo-verify`} component={Unclaimedcargoverify} />
      <Route path={`${match.url}freight-market-rate-List`} component={UpdatefreightratList} />
      <Route path={`${match.url}freight-market-watch`} component={Updatefreightexporter} />
      <Route path={`${match.url}updatefreightrate`} component={UpdatesfreightRates} />
      <Route path={`${match.url}freight-market-rate-List`} component={UpdatefreightratList} />
      <Route path={`${match.url}freight-market-watch`} component={Updatefreightexporter} />
      <Route path={`${match.url}freight-market-watch-Details`} component={UpdatefreigtrateDetails} />
      <Route path={`${match.url}freight-market-watch-all-details/all-quotes`} component={UpdateAllfreightrates} />
      <Route path={`${match.url}banner-view`} component={BannerView} />
      <Route path={`${match.url}exporter-Data`} component={ExporterData} />
      <Route path={`${match.url}sell-rodtep`} component={sellRODTEP}/>
      <Route path={`${match.url}chat-message`} component={chatMessages}/>
      <Route path={`${match.url}subscription-User`} component={subscriptionUser}/>
      <Route path={`${match.url}policy-updates`} component={userPolicyUpdates}/>
      <Route path={`${match.url}rfq-freight-rate`} component = {requestFreightRates} />
      <Route path={`${match.url}rfq-cha`} component = {requestCha} />
      <Route path={`${match.url}offer-your-cargo`} component = {offerYourCargo} />
      <Route path={`${match.url}cargo-offers`} component = {cargoOffers} />
      <Route path={`${match.url}price-calculator`} component = {priceCalculator} />
      <Route path={`${match.url}offer-your-cargo-exporter`} component = {offerYourCargoExporter}/>
      {/* <Route path={`${match.url}cargo-offers-buyer`} component={cargoOffersBuyer}/> */}
      <Route path={`${match.url}cargo-offers-buyer`} component={cargoOfferAdminToBuyer}/>
      <Route path={`${match.url}freight-bookings`} component={FreightBookings} />
      <Route path={`${match.url}business-card-requests-exporter`} component={exporterBusinessCard}/>
      <Route path={`${match.url}business-card-requests-freightforwarder`} component={FreightBusinessCard}/>
      <Route path={`${match.url}contact-details`} component={contactDetails}/>
    </Switch>
  </div>
  </GTMWrapper>
);

export default React.memo(App);
